const showScrollTop = () => {
    if (document.querySelector('.main-area__top')) {
        document.addEventListener('click', ev => {
            if (!ev.target.closest('.main-area__top--button')) return;
            // This prevents the page from scrolling down to where it was previously.
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            window.scrollTo(0, 0);
        })
        window.onscroll = () => {

            if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
                document.querySelector('.main-area__top').classList.add('main-area__top-show');


            } else {
                if (document.querySelector('.main-area__top').classList.contains("main-area__top-show")) {
                    document.querySelector('.main-area__top').classList.remove("main-area__top-show");
                }

            }
        }
    }
}
export default showScrollTop;

